export default __webpack_public_path__ + "static/media/art-s.11b46e87.jpg";